export default __webpack_public_path__ + "static/media/icn6.f74fa516.PNG";